var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as THREE from "three";
import { useEffect, useState } from "react";
import { useGLTF } from "@react-three/drei";
export default function VTMovementHotspot(_a) {
    var position = _a.position, onHotspotClick = _a.onHotspotClick, rotation = _a.rotation, _b = _a.scale, scale = _b === void 0 ? 1 : _b;
    var _c = __read(useState(false), 2), hovered = _c[0], setHovered = _c[1];
    // @ts-ignore
    var nodes = useGLTF("/movement.glb").nodes;
    useEffect(function () {
        document.body.style.cursor = hovered ? "pointer" : "grab";
    }, [hovered]);
    return (_jsx(_Fragment, { children: _jsxs("group", __assign({ dispose: null, scale: scale, position: position, onClick: function () {
                onHotspotClick();
            }, rotation: rotation, onPointerOver: function () { return setHovered(true); }, onPointerOut: function () { return setHovered(false); } }, { children: [_jsx("mesh", { geometry: new THREE.CylinderGeometry(1, 1, 0.5, 12), material: new THREE.MeshBasicMaterial({
                        // leaving this in so you can uncomment to debug
                        // color: 0xaaaaaa,
                        // wireframe: true,
                        visible: false,
                    }), position: [0, 0, 0], scale: 1 }), _jsx("mesh", { geometry: nodes.Circle.geometry, material: new THREE.MeshBasicMaterial({
                        color: 0xffffff,
                        opacity: hovered ? 0.9 : 0.5,
                        transparent: true,
                    }), position: [0, 0, 0], scale: hovered ? [1.5, 0.28, 1.5] : [1, 0.23, 1] }), _jsx("mesh", { geometry: nodes.Circle001.geometry, material: new THREE.MeshBasicMaterial({
                        color: 0xffffff,
                        opacity: hovered ? 0.9 : 0.5,
                        transparent: true,
                    }), position: [0, 0, 0], scale: hovered ? [1.5, 0.28, 1.5] : [1, 0.23, 1] })] })) }));
}
useGLTF.preload("/movement.glb");
